// ShopifyAuthForm.tsx
import React from "react";
import { Form, Input, Typography } from "antd";

const { Title } = Typography;

interface ShopifyAuthFormProps {
  shopify_api_key?: string;
  shopify_hostname?: string;
}

const ShopifyAuthForm: React.FC<ShopifyAuthFormProps> = ({
  shopify_api_key,
  shopify_hostname,
}) => {
  return (
    <div style={{ maxWidth: 400, margin: "0 auto", padding: 24 }}>
      <Title level={2}>
        <img
          src="https://cdn.shopify.com/assets/images/logos/shopify-bag.png"
          alt="Shopify Logo"
          style={{ height: 32, marginRight: 10, verticalAlign: "middle" }}
        />
        Shopify
      </Title>

      <Form layout="vertical">
        <Form.Item label="Store" required>
          <Input
            placeholder="your-store.myshopify.com"
            value={shopify_hostname}
            disabled
            aria-label="Shopify Store"
          />
        </Form.Item>

        <Form.Item label="Access Token" required>
          <Input.Password
            placeholder="Enter your access token"
            value={shopify_api_key}
            disabled
            aria-label="Shopify Access Token"
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default ShopifyAuthForm;
